<template>
  <div
    class="absolute left-0 z-10 flex flex-col w-full bg-primary-purple"
    style="top: 45px; height: calc(100vh - 45px)">
    <div v-show="showContactSalesBtn" class="flex w-full mt-4 account-links">
      <button
        class="account-link account-link--purple w-full font-artlist-sans-bold"
        @click="openEnterpriseTypeForm"
      >
        Contact Sales
      </button>
    </div>
    <div
      v-if="!isLoggedIn || onTrial"
      class="flex w-full mt-4 account-links"
    >
      <a
        v-if="!isLoggedIn"
        href="/pricing/"
        class="flex-1 mr-3 account-link account-link--primary ab-start-free-now"
        @click.prevent="clickOnFreeTrial('Start Free Now')">
        Start Free Now
      </a>
      <a
        v-if="$store.getters.hasContinuityPlan"
        href="/account/subscription/"
        class="w-full account-link account-link--primary">
        Upgrade
      </a>
      <a
        v-else-if="onTrial && hasReferralCode && !isPlOrSqlUser"
        href="/pricing/"
        class="w-full account-link account-link--primary"
        @click="onLinkClick">
        Get 2 Extra Months
      </a>
      <a
        v-else-if="onTrial && !isPlOrSqlUser"
        href="/pricing/"
        class="w-full account-link account-link--primary"
        @click="
          eventTracker(analyticsEvents.clickOnGetALicense, {
            source: 'top nav',
            button_name: 'Get a license',
          })
        "
      >
        Subscribe Now
      </a>
      <a
        v-else-if="$store.getters.userType !== 'paid'"
        href="/pricing/"
        class="account-link account-link--outline flex-1 font-artlist-sans-bold"
        @click="closeMenuAndTrackPricingClickEvents"
      >
        Pricing
      </a>
    </div>
    <div
      v-if="isMonthlyUpgradeBtnShow"
      class="account-links mt-4 flex w-full"
    >
      <a
        href="/pricing/upgrade/annual/"
        class="account-link account-link--primary w-full font-bold"
        @click="trackEventForMonthlyUpgradeButtonClick">
        Upgrade
      </a>
    </div>
    <div class="flex-1 overflow-auto">
      <div
        v-if="!activeSection"
        class="flex flex-col pt-2"
      >
        <div class="subcat">
          categories
        </div>
        <template v-for="(link, key) in links">
          <component
            :is="link.link ? 'a' : 'button'"
            v-if="key !== 'pricing'"
            :key="key"
            v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: key }"
            type="button"
            :href="link.link"
            :target="link.openInNewTab ? '_blank' : '_self'"
            class="drawer-link"
            @click="openSubcategory(key, link.link)"
          >
            <div class="drawer-link__content">
              <div class="flex items-center">
                <img v-if="link.icon" :src="`/assets/images/shared/${link.icon}.png`" class="mr-[6px]"  />
                {{ link.text }}
                <div
                  v-if="link.isNew"
                  class="ml-2 rounded bg-primary-offwhite px-[4px] py-[2px] text-[10px] font-bold text-primary-purple">
                  NEW
                </div>
              </div>
              <i
                v-if="!link.link"
                class="fa-regular fa-chevron-right nav-arrow"
              />
            </div>
          </component>
        </template>
      </div>

      <a
        v-if="!isLoggedIn"
        href="/account/login/"
        class="drawer-link"
        @click.prevent="openSignInModal"
      >
        <div class="drawer-link__content">Sign In</div>
      </a>

      <a
        v-if="!activeSection && showReferAFriendLink"
        href="/referral/"
        class="drawer-link"
        @click="clickReferAFriend"
      >
        <div class="drawer-link__content">Refer a friend</div>
      </a>

      <div v-if="activeSection">
        <button
          type="button"
          class="mx-4 my-5 text-lg capitalize selected-category text-white font-medium"
          @click="closeCategory">
          <i class="mr-2 fa-regular fa-chevron-left nav-arrow" />
          {{ links[activeSection].text }}
        </button>
        <a
          v-for="subItem in subcategoriesLinks.children"
          :key="subItem.text"
          slot="link"
          :href="subItem.link"
          @click="clickOnSubcategory(subItem.text, subItem.link)"
        >
          <div class="drawer-link__content drawer-link">
            <div class="ml-2 mr-auto">{{ subItem.text }}</div>
          </div>
        </a>
      </div>
      <button
        v-if="isLoggedIn && !activeSection"
        v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'log out' }"
        class="drawer-link w-full"
        @click="logout"
      >
        <div class="drawer-link__content">
          <div>Log Out</div>
        </div>
      </button>
      <DrawerFooter class="mb-3" />
    </div>
    <TypeformPopup
      ref="enterpriseTypeform"
      :typeform-id="typeFormID"
      @typeFormSubmitted="typeFormSubmitted = $event"
    />
    <TypeFormThankYouPage
      v-if="showTypeFormThankYouPage"
      :is-pricing-page="false"
      @typeFormSubmitted="typeFormSubmitted = $event"
    />
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker, reset } from '@/utils/eventTracker';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';
import getContext from '@/utilities/get-context';
import {
  CONTIUNITY_PLAN_BILLING_ID,
  CONTIUNITY_PLAN_BILLING_ID_EUR,
  CONTIUNITY_PLAN_BILLING_ID_GBP,
  MONTHLY_BILLING_ID,
  MONTHLY_BILLING_ID_EUR,
  MONTHLY_BILLING_ID_GBP,
  COOKIES,
  USER_LEAD_TYPE,
  TYPE_FORM_ID,
} from '@/constants';
import { CURRENCIES } from '@/constants/currencies';
import DrawerFooter from './footer';
import CategoryIcon from '../../CategoryIcon/index.vue';
import TypeformPopup from '../../Plans/typeform-popup.vue';
import TypeFormThankYouPage from '../../TypeForm/thank-you-modal.vue';

export default {
  components: {
    DrawerFooter,
    CategoryIcon,
    TypeformPopup,
    TypeFormThankYouPage,
  },

  inject: ['links'],

  props: {
    hasReferralCode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    activeSection: '',
    eventTracker,
    analyticsEvents,
    typeFormSubmitted: false,
  }),

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    onTrial() {
      return this.$store.getters.userType === 'free' || this.$store.getters.userType === 'past_due';
    },

    subcategoriesLinks() {
      const currentCategory = this.activeSection;
      return this.links[currentCategory];
    },
    pricingLink() {
      return this.$store.getters.userType === 'past_due' ? '/account/billing' : '/pricing/';
    },
    isAdmin() {
      return this.$store.state.user?.is_team_admin;
    },
    isHasTeam() {
      return this.$store.state.user?.has_team;
    },
    showReferAFriendLink() {
      return this.isLoggedIn && !this.isAdmin && !this.isHasTeam;
    },
    showReferralIconToVisitor() {
      return this.$store.getters.userType === 'visitor' && this.hasReferralCode;
    },
    isPaidUser() {
      return this.$store.getters.userType === 'paid';
    },
    continuityPlanBillingId() {
      switch (this.$store.state.currencyCode) {
        case CURRENCIES.EUR:
          return CONTIUNITY_PLAN_BILLING_ID_EUR;
        case CURRENCIES.GBP:
          return CONTIUNITY_PLAN_BILLING_ID_GBP;
        default:
          return CONTIUNITY_PLAN_BILLING_ID;
      }
    },
    monthlyPlanBillingId() {
      switch (this.$store.state.currencyCode) {
        case CURRENCIES.EUR:
          return MONTHLY_BILLING_ID_EUR;
        case CURRENCIES.GBP:
          return MONTHLY_BILLING_ID_GBP;
        default:
          return MONTHLY_BILLING_ID;
      }
    },
    isMonthlyUpgradeBtnShow() {
      const { plan } = getContext().__MA__.user;
      const hasMonthlyPlan = plan === this.monthlyPlanBillingId;
      return this.isPaidUser && hasMonthlyPlan;
    },
    isPlOrSqlUser() {
      const leadInfoJourney = Cookies.get(COOKIES.NAMES.LEAD_INFO_JOURNEY);
      return (
        leadInfoJourney?.includes(USER_LEAD_TYPE.PL)
        || leadInfoJourney?.includes(USER_LEAD_TYPE.SQL)
      );
    },
    typeFormID() {
      return this.isPlOrSqlUser ? TYPE_FORM_ID.PL_JOURNEY : TYPE_FORM_ID.ENTERPRISE;
    },
    showTypeFormThankYouPage() {
      return this.$store.state.user?.id && !this.openTypeFormPopup && this.typeFormSubmitted;
    },
    showContactSalesBtn() {
      return this.isPlOrSqlUser && this.isLoggedIn;
    },
  },
  methods: {
    openSubcategory(key) {
      this.clickOnCategory(key);
      const link = this.links[key];
      if (link.link) {
        this.trackNavigationClickEvent(link.name, link.link);
        return;
      }
      this.activeSection = key;
    },

    clickOnCategory(sectionName) {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: sectionName,
        clickSource: 'drawer',
      });
    },

    closeCategory() {
      this.activeSection = '';
    },

    clickOnSubcategory(name, link) {
      eventTracker(analyticsEvents.clickOnSubcategory, {
        subCategoryName: name,
        clickSource: 'drawer',
      });
      this.trackNavigationClickEvent(name, link);
    },

    clickOnFreeTrial(buttonName) {
      this.$emit('close');
      this.$store.dispatch('setOpenSignUpModal', {
        open: true,
        clickSource: 'main navigation',
        buttonName,
      });
      eventTracker(analyticsEvents.clickStartFreeTrial, {
        source: 'drawer',
        button_name: buttonName,
      });
    },
    logout() {
      sessionStorage.removeItem('isDunningPopupClosed');
      sessionStorage.removeItem('isDunningSnackbarClosed');
      Cookies.remove(COOKIES.NAMES.LEAD_INFO_CLASSIFICATION);
      Cookies.remove(COOKIES.NAMES.LEAD_INFO_JOURNEY);
      reset();
      window.location.href = '/account/logout/';
    },
    trackNavigationClickEvent(clickText, clickUrl) {
      const eventData = {
        type: 'header',
        clickText,
        clickUrl,
      };
      eventTracker(analyticsEvents.navigationClick, eventData);
      dataLayerTrack({ eventName: gtmEvents.navigationClick, data: eventData });
    },
    clickReferAFriend() {
      eventTracker(analyticsEvents.buttonClicked, {
        flow: 'refer a friend',
        button_name: 'refer a friend',
        next_url: '/referral/',
        click_source: 'menu',
      });
    },
    onLinkClick() {
      eventTracker(analyticsEvents.buttonClicked, {
        flow: 'refer a friend',
        button_name: 'Get 2 Extra Months',
        next_url: '/pricing',
        click_source: 'navigation bar',
      });
    },
    enterpriseClick() {
      this.trackNavigationClickEvent('Business', '/business/');

      eventTracker(analyticsEvents.buttonClicked, {
        button_name: 'Business',
        flow: 'enterprise form',
        next_url: 'https://motionarray.com/business/',
        click_source: 'navigation bar',
      });
    },
    trackEventForMonthlyUpgradeButtonClick() {
      eventTracker(analyticsEvents.buttonClicked, {
        button_name: 'Upgrade',
        next_url: '/pricing/upgrade/annual/',
      });
    },

    openSignInModal() {
      this.$emit('close');
      this.$store.dispatch('setOpenSignInModal', {
        open: true,
        clickSource: 'main navigation',
        buttonName: 'Sign In',
      });

      this.trackSignInClickEvents();
    },
    closeMenuAndTrackPricingClickEvents() {
      this.$emit('close');
      this.trackPricingClickEvents();
    },
    trackSignInClickEvents() {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: 'sign in',
        clickSource: 'drawer',
      });
      eventTracker(analyticsEvents.navigationClick, {
        clickUrl: 'sign in popup',
        type: 'menu',
      });
      eventTracker(analyticsEvents.myAccountArea.menuItemChosen, {
        menu: 'drawer',
        item: 'sign in',
      });
    },
    trackPricingClickEvents() {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: 'pricing',
        clickSource: 'drawer',
      });
      eventTracker(analyticsEvents.navigationClick, {
        clickUrl: '/pricing/',
        type: 'menu',
      });
      eventTracker(analyticsEvents.myAccountArea.menuItemChosen, {
        menu: 'drawer',
        item: 'pricing',
      });
      eventTracker(analyticsEvents.clickPricing, {
        clickSource: 'drawer CTA',
      });
    },
    openEnterpriseTypeForm() {
      eventTracker(analyticsEvents.contactSalesButtonClicked, {
        button_text: 'Contact Sales',
        click_source: 'Drawer',
        component: 'Drawer',
      });
      this.$nextTick(() => {
        this.$refs?.enterpriseTypeform.toggle();
      });
    },
  },
};
</script>

<style>
.nav-arrow {
  @apply text-white text-sm;
}

.subcat {
  margin: 22px 16px 12px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  @apply text-p40;
}

.account-links {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 10px;
}

.account-link {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;

  border-radius: 4px;
  @apply font-bold;
}

.drawer-link {
  display: block;
  cursor: pointer;
}

.drawer-link__content {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 18px;
  @apply border-b border-p10 text-p40;
}

.subcategory-icon > svg > path:first-child {
  fill: #b2b2b2;
}

.subcategory-icon > svg > path:last-child {
  fill: #fff;
}

.selected-category {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.account-link--outline {
  @apply border border-primary-offwhite text-primary-offwhite;
}

.account-link--primary {
  @apply bg-primary-green text-primary-purple;
}
.text-\[10px\] {
  font-size: 10px;
}
.py-\[2px\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.mr-\[6px\] {
  margin-right: 6px;
}
.px-\[4px\] {
  padding-right: 4px;
  padding-left: 4px;
}
</style>
